// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lKeJm","colMin":"styles_colMin__3BkNL"};